/** @format */

/********************
 **  Root-Reducer  **
 ********************/

import { combineReducers } from 'redux';
import { history } from 'stateContainer/history';
import { connectRouter } from 'connected-react-router';
import * as actionTypes from 'stateContainer/action-types';
import { loginReducer } from 'stateContainer/reducers/login-reducer';
import { activeNavReducer } from './activeindex-reducer';
import { sendEmailReducer } from 'stateContainer/reducers/send-email-reducer';
import { notificationReducer } from './notification-reducer';
import { brokerProfileReducer } from './broker-profile-reducer';
import { brokerObjectsReducer } from './broker-objects-reducer';
import { brokerObjectReducer } from './broker-object-reducer';

const appReducer = combineReducers({
  router: connectRouter(history),
  session: loginReducer,
  activeNav: activeNavReducer,
  sendEmail: sendEmailReducer,
  notifications: notificationReducer,
  brokerProfile: brokerProfileReducer,
  brokerObjects: brokerObjectsReducer,
  brokerObject: brokerObjectReducer
});

const rootReducer = (state, action) => {
  if (action.type === actionTypes.LOGOUT_SUCCESS) {
    return {
      router: state.router
    };
  }
  return appReducer(state, action);
};

export default rootReducer;
